import { ActionContext, Module } from 'vuex'
import { AiCompanyState, RootState } from '../store/state_models'

import { AiWrapperService } from '../services'
import affiliate from './affiliate'
import { awaitToJS } from '@/util/await-to-js'
import { company } from './company'

export const aiCompanyPlan: Module<AiCompanyState, RootState> = {
  namespaced: true,
  state: {
    isSeasonOfAIEnabled: undefined,
    updatedAt: undefined,
    seasonOfAI: undefined,
    affiliateCode: undefined,
    featureFlags: {
      flags: {
        GlobalSOAIEnabled: false,
        SummerOfAIEnabled: false,
      },
      companyId: undefined,
    }
  },
  getters: {
    isSOAEnabled: (state: AiCompanyState) => {
      return state.isSeasonOfAIEnabled
    },
    getSeasonOfAiConfig: (state: AiCompanyState) => {
      return state.seasonOfAI
    },
    getFeatureFlags: (state: AiCompanyState) => {
      return state.featureFlags
    },
    getAffiliateCode: (state: AiCompanyState) => {
      return state.affiliateCode
    }
  },
  mutations: {
    updateSOAEnabled: (state: AiCompanyState, payload: boolean) => {
      state.isSeasonOfAIEnabled = payload
      state.updatedAt = Date.now()
    },
    updateSeasonOfAiConfig: (state: AiCompanyState, payload: object) => {
      state.seasonOfAI = payload
      state.updatedAt = Date.now()
    },
    setSeasonOfAI: (state: AiCompanyState, payload: object) => {
      console.log('payload SOAI SPMTS', payload)
      state.seasonOfAI = payload
    },
    updateFeatureFlags: (state: AiCompanyState, payload: { flags: { GlobalSOAIEnabled: boolean, SummerOfAIEnabled: boolean }, companyId: string }) => {
      state.featureFlags = payload    },
    updateAffiliateCode: (state: AiCompanyState, payload: string) => {
      console.log('payload affiliate AffiliateCode SPMTS', payload)
      state.affiliateCode = payload
      console.log('state.affiliateCode SPMTS', state.affiliateCode)
    }
  },
  actions: {
    syncFeatureFlags: async (
      context: ActionContext<AiCompanyState, RootState>,
    ) => {
      const companyId = company?.state?.company.id
      if (!companyId) return
      const [err_feature_flag, feature_flag_response] = await awaitToJS(AiWrapperService.fetchFeatureFlags(companyId))
      if (err_feature_flag) {
        return
      }
      if(feature_flag_response) {
        context.commit('updateFeatureFlags', feature_flag_response)
      }
    },
    syncAll: async (
      context: ActionContext<AiCompanyState, RootState>,
    ) => {
      const companyId = company?.state?.company?.id
      if (!companyId) return

      try {
        const [err, response] = await awaitToJS(AiWrapperService.fetchAICompanyPlan(companyId))
        if (err) {
          return
        }
        console.log('response', response)
        console.log('affiliateCode', response.affiliateCode)

        // const [err_feature_flag, feature_flag_response] = await awaitToJS(AiWrapperService.fetchFeatureFlags(companyId))
        // console.log('feature_flag_response', feature_flag_response)
        // if (err_feature_flag) {
        //   return
        // }
        // if(feature_flag_response) {
        //   context.commit('updateFeatureFlags', feature_flag_response)
        // }

        const event = 1735700400000 // '31 December 2024 22:00 EST'
        if(response && response.seasonOfAIOffer) {
          context.commit('setSeasonOfAI', response.seasonOfAIOffer)
        } else {
          context.commit('setSeasonOfAI', {})
        }

        if(response && response.affiliateCode) {
          console.log('affiliateCode Commiting', response.affiliateCode)
          context.commit('updateAffiliateCode', response.affiliateCode)
        }

        if(response 
          && (('seasonOfAIDisabled' in response && response.seasonOfAIDisabled === false) || !('seasonOfAIDisabled' in response))
          && Date.now() <= event) {
          context.commit('updateSOAEnabled', true)
        } else {
          context.commit('updateSOAEnabled', false)
        }
       

        console.log(`all getters`, context.getters)

      } catch (err) {
        console.log('err', err)
        context.commit('updateSOAEnabled', false)
      } finally {
        console.log(`all getters`, context.getters)
      }
    },
    updateSOAEnabled: (context: ActionContext<AiCompanyState, RootState>, payload: boolean) => {
        context.commit('updateSOAEnabled', payload)
    },
    updateSeasonOfAiConfig: (context: ActionContext<AiCompanyState, RootState>, payload: object) => {
      context.commit('setSeasonOfAI', payload)
    },
    updateFeatureFlags: (context: ActionContext<AiCompanyState, RootState>, payload: { flags: { GlobalSOAIEnabled: boolean, SummerOfAIEnabled: boolean }, companyId: string }) => {
      context.commit('updateFeatureFlags', payload)
    }
  },
}
